import $ from 'jquery';
import React from 'react';
import Helmet from 'react-helmet';

import Navbar from '../../components/navbar/navbar';
import MainLayout from '../../layouts/layout';
import Button from '../../components/button/button';
import SuperHeader from '../../components/typographies/superheader';
import Header1 from '../../components/typographies/header1';
import Header2 from '../../components/typographies/header2';
import Para1 from '../../components/typographies/para1';
import Para2 from '../../components/typographies/para2';
import Quote from '../../components/typographies/quote';
import Tags from '../../components/list/tags.js';
import { CaseStudyFooter } from '../../components/footer/footer';

import JuerixHomepage from '../../static/images/JuerixHomepage.png';

import Link from 'gatsby-link'

const tags = [{
  tag: 'Branding',
  label: 'Branding'
},
{
  tag: 'Design',
  label: 'UI Design'
},
{
  tag: 'Develop',
  label: 'Development'
}];

export default class Project extends React.Component {
  render() {
    return (
      <MainLayout key="main-layout">
        <Helmet>
          <title>Case Study: Juerix. Designing an Ecosystem</title>
          <meta name="description" content="Incorporating trust, quality & credibility in an online designer jewellery marketplace" />
          <meta property="og:url" content="https://surebro.com/case-studies/juerix" />
          <meta property="og:title" content="Case Study: Juerix. Designing an Ecosystem" />
          <meta property="og:description" content="Incorporating trust, quality & credibility in an online designer jewellery marketplace" />
          <meta property="og:image" content="https://res.cloudinary.com/surebro/image/upload/v1530280290/Social-share-cover_t18uos.png" />
        </Helmet>
        <Navbar key="navbar" active={1} className="blue" />
        <div className="CaseStudy">
          <section className="container CaseStudy-banner">
            <div className="row justify-content-flex-start">
              <SuperHeader
                  key="title"
                  className="text-left darkgray stronger"
                  text="Designing an Ecosystem"
              />
            </div>
            <div className="row justify-content-flex-start">
              <Header1
                  key="subtitle"
                  className="text-left grey regular CaseStudy-banner-subtitle"
                  text="Incorporating trust, quality & credibility in an online designer jewellery marketplace."
              />
            </div>
            <Tags
                key="project-tags"
                tags={tags}
            />
          </section>
          <section className="container CaseStudy-body">
            <Header2 text="A marketplace like no other" />
            <Para1
                key="text-1"
                className="text-left grey"
                text="The founders of Juerix had a vision for what they wanted Juerix to be. They wanted to build a designer jewellery marketplace where quality is guaranteed. They wanted this to be very clear in all their customer facing products."
            />
            <Para1
                key="text-2"
                className="text-left grey"
                text="Juerix was going to showcase and sell designs from awards winning jewellery designers and we were asked to built something that did justice to the designers."
            />
          </section>
          <br />
          <br />
          <section className="container CaseStudy-body">
            <Quote text="Our aim was to build our version of Art">
            </Quote>
          </section>
          <br />
          <br />
          <section className="CaseStudy-product-design">
            <img className="CaseStudy-product-design-image" src="https://res.cloudinary.com/surebro/image/upload/q_auto/case-study/juerix/JuerixHomepage.c494db9c" alt="juerix"/>
            <div className="CaseStudy-product-design-content">
              <Header1
                key="title"
                className="text-left strong"
                text="Seven seconds to Impress"
              />
              <Header2
                key="subtitle"
                className="text-left grey regular"
                text="We had to communicate Juerix's USP to users while also balancing
                it with it's business requirements. All that within a small window"
              />
              <br />
              <Para2
                key="intro"
                className="text-left grey regular"
                text="An average user will form an opinion of a website within the first
                seven seconds. It was important we could communicate core values to the
                user within seven seconds."
              />
              <br />
              <Para2
                key="intro-2"
                className="text-left grey regular"
                text="We also had to balance this with business requirements. Juerix is
                a business and without sales, it wouldn't be worth the designer's time
                to invest in Juerix."
              />
              <br />
              <Para2
                key="intro-3"
                className="text-left grey regular"
                text="Those two requirements forced us to try something new. At the end of the day
                we were quite happy with the result. It performed well business wise
                without compromising on the Juerix brand"
              />
              <br />
            </div>
          </section>
          <CaseStudyFooter />
        </div>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/case-studies/juerix.js